const en = {
	logo:'BOOKLUAR',
	searchPlaceholder:'Search book, author, or puplsher',
	bestSeller : "Best seller" ,
	classicNovels: "Classic novels",
	History : "History",
	title : "Title",
	author: "Author",
	publisher: "Publisher" ,
	publishedDate: " Published Date",
	read:" read",
	speakNow: "Speak Now",
    technology:"Technology",
    philosophy:"philosophy",
    ReligiousBooks:"Religious books",
    Fiction: "Fiction",
    categories:"Categories",
    more:"More"


};

export default en;